import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { ItemEditBtns } from '../../services/itemeditbtns/itemeditbtns';

export const EmailFooter = {
    components: {
        ItemEditBtns
    },
    props: {
        tagClass: String
    },
    methods: {

    },
    computed: {
        ...mapState(vplSiteStore, ['templateData'])
    },
    template: `
        <ItemEditBtns  v-if="templateData && templateData.mail && templateData.mail.EDIT_BUTTON" :onclick="templateData.mail.EDIT_BUTTON">
            Редактировать e-mail
        </ItemEditBtns>
        <a  v-if="templateData && templateData.mail && templateData.mail.CONTENT"
            :href="'mailto:' + templateData.mail.CONTENT" class="mob-contacts__mail js-copymail"
            >
            {{ templateData.mail.CONTENT }}
        </a>
    `
}